/**
 * This file provides an interface to handle service worker updates in the Vue application.
 * It requires being run by a service worker in GenerateSW mode.
 */

const ASK_BEFORE_REFRESH = false

let initialised = false
let refreshing = false
let registration = null
let quasarObj = null

// Called when the user accepts the update
function refreshApp () {
  // Make sure we only send a 'skip waiting' message if the SW is waiting
  if (!registration?.waiting) return
  // Send message to SW to skip the waiting and activate the new SW
  registration.waiting.postMessage({ type: 'SKIP_WAITING' })
}

function showRefreshNotification () {
  quasarObj.notify({
    message: `An update is available.`,
    html: true,
    color: 'black',
    icon: 'system_update',
    actions: [ { label: 'refresh all tabs', color: 'white', handler: refreshApp } ],
    timeout: 0
  })
}

// Store the Service Worker registration so we can send it a message.
function updateAvailable (event) {
  registration = event.detail
  if (ASK_BEFORE_REFRESH) {
    showRefreshNotification()
  } else {
    refreshApp()
  }
}

export default function initServiceWorkerUpdates ($q) {
  if (initialised) {
    console.error('Cannot initialise the service worker updates module twice.')
    return
  }
  initialised = true

  quasarObj = $q

  // Listen for our custom event from the SW registration
  document.addEventListener('swUpdated', updateAvailable, { once: true })

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Prevent multiple refreshes
    if (refreshing) return
    refreshing = true
    // Here the actual reload of the page occurs
    window.location.reload()
  })
}
